<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'monitoringsCrud'"
            :crudName="$t('Monitoring')"
            :newText="$t('Add') + '  ' + $t('New')"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="false"
            :enableEdit="false"
            :enableDelete="false"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
            :customFilters="customFilters"
            @filtered_ds="filtered_ds"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      customFilters: [
        {
          name: "created_at_f",
          type: "calendar",
          call: "filtered_ds",
        },
      ],
      created_at: "",
      table: "monitoringsTable",
      showMessageImport: false,
      monitoringsCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "area_id",
        "vehicle_id",
        "event_type",
        "event_description",
        "created_at_f"
      ],
      tableData: [
        "id",
        "area_id",
        "vehicle_id",
        "event_type",
        "event_description",
        "created_at"
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "area_id",
          "vehicle_id",
          "event_type"
        ],
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll",
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t("id"),
          area_id: this.$t("Area"),
          vehicle_id: this.$t("Vehicle"),
          event_type: this.$t("Event Type"),
          event_description: this.$t("Event Description"),
          created_at_f: this.$t("Created At"),
          actions: this.$t("action"),
        },
        texts: {
          filterBy: this.$t("Filter"),
          defaultOption: this.$t("Select"),
        },
        listColumns: {
          event_type: [
            { id: 'entry', text: 'Entrada' },
            { id: 'exit', text: 'Saída' }
          ]
        },
        templates: {
          vehicle_id: function (h, row, index) {
            return row.vehicle ? row.vehicle.name : "";
          },
          area_id: function (h, row, index) {
            return row.area ? row.area.name : "";
          },
          event_type: (h, row, index) => {
            const translations = {
              entry: this.$t('Entry'),
              exit: this.$t('Exit'),
            };
            return translations[row.event_type] || row.event_type;
          },
          event_description: function (h, row) {
            if (!row.event_description) return '';

            let description = row.event_description;

            const translations = {
              'Initial log: Vehicle entry area': this.$t('Initial log: Vehicle entry area'),
              'Initial log: Vehicle exit area': this.$t('Initial log: Vehicle exit area'),
              'State changed: Vehicle entry area': this.$t('State changed: Vehicle entry area'),
              'State changed: Vehicle exit area': this.$t('State changed: Vehicle exit area'),
              ' at position ': ' ' + this.$t('at position') + ' ',
            };

            for (const [key, value] of Object.entries(translations)) {
              if (description.includes(key)) {
                description = description.replace(key, value);
              }
            }

            return description;
          }
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;

          if (
              this.$parent.$parent.$parent.created_at != null &&
              this.$parent.$parent.$parent.created_at != ""
          ) {
            requestData.params.created_at =
                this.$parent.$parent.$parent.created_at;
          }
          requestData.params.query = "";
          requestData.params.with = ["vehicle", "area"];

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      endPoint: "monitorings",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    filtered_ds(date) {
      this.created_at = date;
    },
    query: function (query) {
      const columns = {
        id: "id",
        vehicle_id: "vehicle[name]",
        area_id: "area[name]",
        event_type: "event_type",
        event_description: "event_description",
        created_at: "created_at"
      };

      let filters = "";

      $.each(query, function (index, value) {
        if (!value) return;
        filters += columns[index] + "=" + encodeURIComponent(value) + "&";
      });

      return filters;
    },
    openInput() {
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
